import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IBbitI18n } from '@bbitgmbh/bbit.utils';
import { BehaviorSubject, Observable } from 'rxjs';

export interface INavItem {
  text: IBbitI18n;
  routerLink: string[];
}

export interface INavChildItem extends INavItem {
  validFor: string[];
  validForStartsWith?: string[];
}

@Injectable({
  providedIn: 'root',
})
export class NavService {
  private _isOnShopPage = new BehaviorSubject<boolean>(false);
  private _activeChildren = new BehaviorSubject<INavItem[]>([]);
  private _childItems: INavChildItem[] = [
    // {
    //   validFor: ['/laden'],
    //   validForStartsWith: ['/laden'],
    //   text: 'Laden',
    //   routerLink: ['/laden'],
    // },
    // {
    //   validFor: ['/shop', '/shop/items'],
    //   validForStartsWith: ['/shop'],
    //   text: 'Shop',
    //   routerLink: ['/shop'],
    // },
    // {
    //   validFor: [],
    //   validForStartsWith: ['/schiessanlage'],
    //   text: 'Schiessanlage',
    //   routerLink: ['/schiessanlage'],
    // },
  ];

  constructor(private _router: Router) {
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('/shop')) {
          this._isOnShopPage.next(true);
        } else {
          this._isOnShopPage.next(false);
        }
        const childItems = this.getChildItems([event.url]);
        this._activeChildren.next(childItems);
      }
    });
  }

  public getMenuItems(): INavItem[] {
    return [
      { text: 'Trainingsflächen', routerLink: ['/places'] },
      { text: 'Campingplätze', routerLink: ['/camping'] },
    ];
  }

  public getChildItems(routerLink: string[]): INavChildItem[] {
    return this._childItems.filter(
      (item) =>
        item.validFor.includes(routerLink.join('/')) ||
        item?.validForStartsWith?.find((v) => routerLink.join('/').startsWith(v)),
    );
  }

  public observeActiveChildren(): Observable<INavItem[]> {
    return this._activeChildren.asObservable();
  }

  public observeIsOnShopPage(): Observable<boolean> {
    return this._isOnShopPage.asObservable();
  }

  public isRouteActive(route: string[]): boolean {
    const r = (route || []).join('/');
    const url = this._router.url;
    // if (url === '/bereiche') {
    //   if (r === '/') {
    //     return true;
    //   }
    // }
    // if (r.startsWith('/shop')) {
    //   if (
    //     url === '/behoerdenrabatt' ||
    //     url === '/informationen-zum-waffenkauf' ||
    //     url === '/geschaeft' ||
    //     url === '/ankauf-von-gebrauchtwaffen' ||
    //     url === '/testwaffenschiessen'
    //   ) {
    //     return true;
    //   }
    // }
    // if (url.startsWith('/kurse')) {
    //   if (r.startsWith('/kurse')) {
    //     return true;
    //   }
    // }
    if (r === '/') {
      return url === r;
    }
    return url.startsWith(r);
  }

  public isChildRouteActive(route: string[]): boolean {
    const r = (route || []).join('/');
    const url = this._router.url;
    if (r === '/') {
      return url === r;
    }
    return url.startsWith(r);
  }
}
